import React, {FC} from 'react'
import {UseFormRegister, FieldErrors,useFormContext} from 'react-hook-form'
type InputProps = {
  name: string
  register: UseFormRegister<any>
  errors: FieldErrors
  onChange?: (e: any) => void
  defaultValue?: string
  minValue?: string
}

const InputDateLav: FC<InputProps> = ({
  name,
  register,
  // errors,
  onChange,
  minValue = '1999-01-01',
  ...props
}) => {
  const { formState:{errors} } = useFormContext()
  return (
    <div className='sdx_form_input'>
      <input
        type='Date'
        className='form-control sdx-centra-input-form'
        {...register(name)}
        min={minValue}
        max={'3999-01-01'}
        onChange={onChange}
        {...props}
      />
      {errors[name] && <p>{errors[name]?.message?.toString()}</p>}
    </div>
  )
}

export default InputDateLav
